import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Button, Dropdown, Input } from 'semantic-ui-react';
import i18next from 'i18next';
import moment from 'moment';

import './BenefitDetails.scss';
import { PhoneInput, DateTimePicker } from '../../common';
import { saveIssue, editEntityField } from '../../../actions';

class IssuesEditor extends Component {

    DEFAULT_STATE = {
        campaignRelated: false,
        limitReusablity: false,
        expires: false,
        distributeToSpecific: false,
        restrictAge: false,
        toNewOnly: false,
        limitPaymentMethods: false
    };
    state = { ...this.DEFAULT_STATE };

    componentWillReceiveProps(nextProps) {
        if (this.props.entity === null && nextProps.entity !== null) {
            this.setState({
                campaignRelated: nextProps.entity.campaignId ? true : false,
                limitReusablity: nextProps.entity.reusability ? true : false,
                expires: nextProps.entity.expirationDate ? true : false,
                distributeToSpecific: nextProps.entity.meta.members ? true : false,
                restrictAge: nextProps.entity.meta.minimumAge || nextProps.entity.meta.maximumAge ? true : false,
                toNewOnly: nextProps.entity.meta.joinedFrom ? true : false,
                limitPaymentMethods: nextProps.entity.meta.paymentTypes ? true : false
            });
        } else if (this.props.entity !== null && nextProps.entity === null) {
            this.setState(this.DEFAULT_STATE);
        }
    }

    handleSubmit = (event) => {
        const { loyaltyProgramId, benefit, entity, saveIssue } = this.props;
        saveIssue(loyaltyProgramId, benefit.id, entity);
        event.preventDefault();
    }

    render() {
        const { benefit, entity, campaigns, editEntityField } = this.props;
        if (!entity) {
            return null;
        }

        const issue = entity || {};

        const campaignsOptions = campaigns.map(rest => ({
            value: rest.id,
            text: rest.name
        }));
        const paymentMethodsOptions = [
            { value: 'american-express', text: 'American Express' },
            { value: 'budget', text: i18next.t('budget') },
            { value: 'diners-club', text: 'Diners Club' },
            { value: 'isracard', text: 'Isracard' },
            { value: 'maestro', text: 'Maestro' },
            { value: 'master-card', text: 'Master Card' },
            { value: 'visa', text: 'Visa' },
        ];
        const chosenCampaign = campaigns.find(campaign => campaign.id === issue.campaignId);

        return (
            <Form onSubmit={this.handleSubmit}>

                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('loyaltyProgram.campaignRelated')}
                        checked={this.state.campaignRelated}
                        onChange={(e, { checked }) => {
                            this.setState({ campaignRelated: checked });
                            if (!checked) editEntityField('campaignId', null);
                        }}
                    />
                </Form.Field>

                {
                    this.state.campaignRelated ?
                        <Form.Field>
                            <label>{i18next.t('loyaltyProgram.campaign')}</label>
                            <Dropdown
                                placeholder={i18next.t('loyaltyProgram.campaigns')}
                                fluid
                                selection
                                options={campaignsOptions}
                                value={chosenCampaign ? chosenCampaign.id : null}
                                onChange={(e, { value }) => editEntityField('campaignId', value)}
                            />
                        </Form.Field>
                        : null
                }

                {
                    benefit.activation === "GLOBAL" ? null :
                        <Form.Field>
                            <Form.Checkbox
                                label={i18next.t('loyaltyProgram.limitReusablity')}
                                checked={this.state.limitReusablity}
                                onChange={(e, { checked }) => {
                                    this.setState({ limitReusablity: checked });
                                    editEntityField('reusability', checked ? 1 : null);
                                }}
                            />
                            {
                                this.state.limitReusablity ?
                                    <Form.Field required>
                                        <label>{i18next.t('loyaltyProgram.reusability')}</label>
                                        <Input required
                                            type="number"
                                            min={1}
                                            placeholder={i18next.t('loyaltyProgram.reusability')}
                                            value={issue.reusability}
                                            onChange={({ target }) => editEntityField('reusability', Number(target.value))}
                                        />
                                    </Form.Field> : null
                            }
                        </Form.Field>
                }

                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('loyaltyProgram.expiration')}
                        checked={this.state.expires}
                        onChange={(e, { checked }) => {
                            this.setState({ expires: checked });
                            if (!checked) editEntityField('expirationDate', null);
                        }}
                    />
                </Form.Field>

                {
                    this.state.expires ?
                        <Form.Field>
                            <label>{i18next.t('expirationDate')}</label>
                            <DateTimePicker
                                value={moment(issue.expirationDate)}
                                onChange={(expirationDate) => {
                                    if (expirationDate) {
                                        expirationDate.set('second', 0);
                                        editEntityField('expirationDate', expirationDate.toDate());
                                    }
                                }}
                               
                            />
                        </Form.Field>
                        : null
                }

                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('loyaltyProgram.distributeToSpecific')}
                        checked={this.state.distributeToSpecific}
                        onChange={(e, { checked }) => {
                            this.setState({ distributeToSpecific: checked });
                            editEntityField('meta', { ...issue.meta, members: checked ? [] : null });
                        }}
                    />
                </Form.Field>

                {
                    this.state.distributeToSpecific ?
                        <Form.Field>
                            <label>{i18next.t('loyaltyProgram.member')}</label>
                            <PhoneInput
                                required
                                value={issue.meta.members[0]}
                                onChange={(phone) => editEntityField('meta', { ...issue.meta, members: [phone] })}
                            />
                        </Form.Field>
                        : null
                }

                {/* <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('ageRestrictions')}
                        checked={this.state.restrictAge}
                        onChange={(e, { checked }) => {
                            this.setState({ restrictAge: checked });
                            editEntityField('meta', {
                                ...issue.meta,
                                minimumAge: checked ? 0 : null,
                                maximumAge: checked ? 0 : null
                            });
                        }}
                    />
                </Form.Field>

                {
                    this.state.restrictAge ?
                    <Form.Group>
                        <Form.Field width={4}>
                            <label>{i18next.t('loyaltyProgram.minimumAge')}</label>
                            <Input
                                type="number"
                                min={0}
                                placeholder={i18next.t('loyaltyProgram.minimumAge')}
                                value={issue.meta.minimumAge}
                                onChange={({ target }) => editEntityField('meta', {
                                    ...issue.meta,
                                    minimumAge: Number(target.value),
                                    maximumAge: Number(target.value) > issue.meta.maximumAge ? Number(target.value) : issue.meta.maximumAge
                                })}
                            />
                        </Form.Field>
                        <Form.Field width={4}>
                            <label>{i18next.t('loyaltyProgram.maximumAge')}</label>
                            <Input
                                type="number"
                                min={issue.meta.minimumAge}
                                placeholder={i18next.t('loyaltyProgram.maximumAge')}
                                value={issue.meta.maximumAge}
                                error={(issue.meta.minimumAge > issue.meta.maximumAge)}
                                onChange={({ target }) => editEntityField('meta', { ...issue.meta, maximumAge: Number(target.value) }) }
                            />
                        </Form.Field>
                    </Form.Group>
                    : null
                } */}

                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('loyaltyProgram.forNewUsers')}
                        checked={this.state.toNewOnly}
                        onChange={(e, { checked }) => {
                            this.setState({ toNewOnly: checked });
                            editEntityField('meta', { ...issue.meta, joinedFrom: null });
                        }}
                    />
                </Form.Field>

                {
                    this.state.toNewOnly ?
                        <Form.Field>
                            <label>{i18next.t('loyaltyProgram.joinedFrom')}</label>
                            <DateTimePicker
                                value={moment(issue.meta.joinedFrom)}
                                onChange={
                                    (newUsersDate) => {
                                        if (newUsersDate) {
                                            newUsersDate.set('second', 0);
                                            editEntityField('meta', { ...issue.meta, joinedFrom: newUsersDate.toDate() });
                                        }
                                    }
                                }
                               
                            />
                        </Form.Field>
                        : null
                }
                
                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('loyaltyProgram.forFirstTimers')}
                        checked={issue.meta.firstPayment}
                        onChange={(e, { checked }) => {
                            editEntityField('meta', { ...issue.meta, firstPayment: checked });
                        }}
                    />
                </Form.Field>

                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('general.paymentMethods')}
                        checked={this.state.limitPaymentMethods}
                        onChange={(e, { checked }) => {
                            this.setState({ limitPaymentMethods: checked });
                            editEntityField('meta', { ...issue.meta, paymentTypes: null });
                        }}
                    />
                </Form.Field>
                {
                    this.state.limitPaymentMethods ?
                        <Form.Field>
                            <label>{i18next.t('general.paymentMethods')}</label>
                            <Dropdown
                                placeholder={i18next.t('general.paymentMethods')}
                                fluid
                                selection
                                options={paymentMethodsOptions}
                                multiple
                                search
                                value={issue.meta.paymentTypes}
                                onChange={(e, { value }) => editEntityField('meta', { ...issue.meta, paymentTypes: value })}
                            />
                        </Form.Field> : null
                }

                {
                    benefit.activation === "VOUCHER" ?
                        <Form.Field required>
                            <label>{i18next.t('loyaltyProgram.benefitCode')}</label>
                            <Input required
                                placeholder={i18next.t('loyaltyProgram.benefitCode')}
                                value={issue.meta.code ? issue.meta.code : ''}
                                onChange={({ target }) => editEntityField('meta', { ...issue.meta, code: target.value })}
                            />
                        </Form.Field>
                        : null
                }

                <Form.Group>
                    <Button type='submit' primary floated="right">
                        {i18next.t('save')}
                    </Button>
                </Form.Group>

            </Form>
        );
    }
}

IssuesEditor.propTypes = {
    loyaltyProgramId: PropTypes.any,
    benefit: PropTypes.object,
    campaigns: PropTypes.array,
    saveIssue: PropTypes.func,
    editEntityField: PropTypes.func,
    entity: PropTypes.object
    
};

function mapStateToProps(state) {
    const { campaigns } = state.loyaltyApp;
    const { entity } = state.editor;

    return { entity, campaigns };
}

export default connect(mapStateToProps, { saveIssue, editEntityField })(IssuesEditor);
